import { v4 as uuidv4 } from 'uuid'


export interface FormOption {
  value: string;
  text: string;
}

export type ElementType =
  | 'text'
  | 'number'
  | 'select'
  | 'textarea'
  | 'email'
  | 'checkbox'
  | 'checkboxGroup'
  | 'date';

export interface ElementForm {
  type: ElementType;
  name: string;
  title: string;
  isRequired: boolean;
  options?: FormOption[];
  /** Nombre del campo en Odoo al que se mapeará este valor (ej: "nombre_pac", "num_hist_clinica") */
  odooField?: string;
}

export interface FormRowItem {
  field: ElementForm;
  width: number; 
}

export interface FormRow {
  id: string;
  items: FormRowItem[];
}




export interface NewProductDTO {
  id: string
  productName: string
  odooNumber: number
  patientForm: FormRow[];
  sampleForm: FormRow[];
}



export class NewProduct {
  _id: string
  _productName: string
  _odooNumber: number
  _patientForm: FormRow[];
  _sampleForm: FormRow[];

  constructor(p: NewProductDTO) {
    this._id = p.id
    this._productName = p.productName
    this._odooNumber = p.odooNumber
    this._patientForm = p.patientForm
    this._sampleForm = p.sampleForm
  }

  get id(): string {
    return this._id
  }

  get productName(): string {
    return this._productName
  }

  get odooNumber(): number {
    return this._odooNumber
  }

  get patientForm(): FormRow[] {
    return this._patientForm
  }

  get sampleForm(): FormRow[] {
    return this._sampleForm
  }
}


export function fromModel(c: NewProduct): NewProductDTO {
  return {
    id: c.id,
    productName: c.productName,
    odooNumber: c.odooNumber,
    patientForm: c.patientForm,
    sampleForm: c.sampleForm,
  }
}

export function toModel(d: NewProductDTO): NewProduct {
  return new NewProduct(d)
}


export function emptyNewProductDTO(): NewProductDTO {
  return {
    id: uuidv4(),
    productName: '',
    odooNumber: 0,
    patientForm: [{
      id: 'row_1',
      items:[{
        field: {
          name: 'firstName',
          title: 'firstName',
          isRequired: true,
          type:'text',
          odooField: 'nombre_pac',
        },
        width: 6
        
      },
      {
        field: {
          name: 'lastName',
          title: 'lastName',
          isRequired: true,
          type:'text',
          odooField: '',
        },
        width: 6
        
      }
      ]
    },
  {
      id: 'row_2',
      items:[{
        field: {
          name: 'dob',
          title: 'dob',
          isRequired: true,
          type:'date',
          odooField: 'fecha_nac_pac',
        },
        width: 6
        
      },
      {
        field: {
          name: 'NHC / DNI',
          title: 'nhc',
          isRequired: true,
          type:'text',
          odooField: 'num_hist_clinica',
        },
        width: 6
        
      }
      ]
    }],
    sampleForm: [{
      id: 'row_1',
      items:[{
        field: {
          name: 'sample',
          title: 'sample',
          isRequired: true,
          type:'select',
          options: [
            {value: "1",text: 'sample 1'},
            {value: "2",text: 'sample 2'},
            {value: "3",text: 'sample 3'},
            {value: "4",text: 'sample 4'},
            {value: "5",text: 'sample 5'},
            {value: "6",text: 'sample 6'},
            {value: "7",text: 'sample 7'},
          ]
        },
        width: 12
        
      },
   
      ]
    },
  {
      id: 'row_2',
      items:[{
        field: {
          name: 'baCode',
          title: 'baCode',
          isRequired: false,
          type:'text'
        },
        width: 6
        
      },
      {
        field: {
          name: 'extrationDate',
          title: 'Fecha de extraccion',
          isRequired: true,
          type:'date'
        },
        width: 6
        
      }
      ]
    }],
  }
}

export interface NewProductQuery {
  id: string
  productName: string
  odooNumber: number
  patientForm: JSON
  sampleForm: JSON
}
